import TaxFormSection from './TaxFormSection';
import ConnectedTaxFormSection, { formName } from './ConnectedTaxFormSection';

export { TaxFormSection, formName };
export default ConnectedTaxFormSection;
